import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import onBarcode from "sdk/onBarcode"

@withRouter
export default class Barcode extends Component {

  componentDidMount() {
    this.unsubscribe = onBarcode( this.goSearch )
  }

  componentWillUnmount() {
    this.unsubscribe && this.unsubscribe()
  }

  goSearch = ( barcode ) => {
    console.log( `goSearch:Barcode`, barcode )
    // history.push( `/ean/${barcode}` )
  }

  render() {
    return null
  }

}



// WEBPACK FOOTER //
// ./src/components/Barcode/Barcode.js